import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { Button } from 'foundations-components/transitional/components/Button';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const url = path => {
  const isQAProxy = window.location.hostname.indexOf('wthubspot') >= 0;
  const isQA = enviro.isQa() || isQAProxy;
  const baseUrl = getFullUrl('app', {
    envOverride: isQA ? 'qa' : 'prod'
  });
  const {
    protocol,
    hostname
  } = parseUrl(baseUrl);
  return buildUrl({
    protocol,
    hostname,
    path
  });
};
const ViewAccountButtonBase = ({
  children,
  uiButtonProps
}) => {
  return /*#__PURE__*/_jsx(Button, Object.assign({
    href: url(`/account-and-billing/${PortalIdParser.get()}`),
    target: "_blank",
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    }
  }, uiButtonProps, {
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.buttons.viewAccount"
    })
  }));
};
export const ViewAccountButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.VIEW_ACCOUNT_BUTTON,
  children: /*#__PURE__*/_jsx(ViewAccountButtonBase, Object.assign({}, props))
});